import { EditorProviderButtonSettings } from '../EditorProviderButtonSettings';
import { customizeCraftJsComponent } from '../../helpers';
import { EditorButton } from '../EditorButton';

export const EditorGoogleButton = customizeCraftJsComponent(EditorButton, {
	name: 'Google Button',
	props: {
		children: '',
		startIcon: 'google',
		shape: 'square',
		variant: 'outline',
		'data-descope-provider': 'google',
		startIconColorText: false,
		formNoValidate: true,
		'data-type': 'social'
	},
	related: {
		settings: EditorProviderButtonSettings
	},
	custom: {
		subType: 'social'
	}
});
